import { createBrowserRouter } from 'react-router-dom';

import PermissionSpecificRoute from '@components/guards/PermissionSpecificRoute';
import PrivateRoute from '@components/guards/PrivateRoute';
import Layout from '@components/layout/Layout';

import ActivateUser from './auth/ActivateUser';
import Login from './auth/Login';
import PasswordReset from './auth/PasswordReset';
import PasswordResetRequest from './auth/PasswordResetRequest';
import DrugsList from './drugs/DrugsList';
import EthnicitiesList from './ethnicities/EthnicitiesList';
import GendersList from './genders/GendersList';
import Home from './home/Home';
import MedicalDoctorDetails from './medicalDoctors/MedicalDoctorDetails';
import MedicalDoctorsList from './medicalDoctors/MedicalDoctorsList';
import MedicalOrganizationDetails from './medicalOrganizations/MedicalOrganizationDetails';
import MedicalOrganizationsList from './medicalOrganizations/MedicalOrganizationsList';
import MedicalSpecialitiesList from './medicalSpecialities/MedicalSpecialitiesList';
import NotFound from './NotFound';
import PathologiesList from './pathologies/PathologiesList';
import PatientDetails from './patients/PatientDetails';
import PatientsList from './patients/PatientsList';
import TherapiesList from './therapies/TherapiesList';
import TherapyDetail from './therapies/TherapyDetail';
import UsersList from './users/UsersList';
import TerraSuccessRedirect from './TerraSuccessRedirect';

export const LOGIN_PATH = 'login';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <PrivateRoute element={<Home />} />,
      },
      {
        path: 'login',
        element: <Login />,
      },
      {
        path: 'password-reset',
        element: <PasswordResetRequest />,
      },
      {
        path: 'password-reset/:token',
        element: <PasswordReset />,
      },
      {
        path: 'terra-success-redirect',
        element: <TerraSuccessRedirect />,
      },
      { path: 'utenti/attivazione/:token', element: <ActivateUser /> },
      {
        path: 'utenti',
        element: (
          <PermissionSpecificRoute
            permission="USERS.READ"
            element={<UsersList />}
          />
        ),
      },
      {
        path: 'organizzazioni-mediche',
        element: (
          <PermissionSpecificRoute
            permission="MEDICAL_ORGANIZATIONS.READ"
            relatedOnly={false}
            element={<MedicalOrganizationsList />}
          />
        ),
      },
      {
        path: 'organizzazioni-mediche/:medicalOrganizationId',
        element: (
          <PermissionSpecificRoute
            permission="MEDICAL_ORGANIZATIONS.READ"
            element={<MedicalOrganizationDetails />}
          />
        ),
      },
      {
        path: 'specialità-mediche',
        element: (
          <PermissionSpecificRoute
            permission="MEDICAL_SPECIALITIES.MANAGE"
            element={<MedicalSpecialitiesList />}
          />
        ),
      },
      {
        path: 'generi',
        element: (
          <PermissionSpecificRoute
            permission="GENDERS.MANAGE"
            element={<GendersList />}
          />
        ),
      },
      {
        path: 'patologie',
        element: (
          <PermissionSpecificRoute
            permission="PATHOLOGIES.MANAGE"
            element={<PathologiesList />}
          />
        ),
      },
      {
        path: 'etnie',
        element: (
          <PermissionSpecificRoute
            permission="ETHNICITIES.MANAGE"
            element={<EthnicitiesList />}
          />
        ),
      },
      {
        path: 'farmaci',
        element: (
          <PermissionSpecificRoute
            permission="DRUGS.MANAGE"
            element={<DrugsList />}
          />
        ),
      },
      {
        path: 'medici',
        element: (
          <PermissionSpecificRoute
            permission="MEDICAL_DOCTORS.READ"
            excludeRoles={['medicalDoctor']}
            element={<MedicalDoctorsList />}
          />
        ),
      },
      {
        path: 'medici/:medicalDoctorId',
        element: (
          <PermissionSpecificRoute
            permission="MEDICAL_DOCTORS.READ"
            element={<MedicalDoctorDetails />}
          />
        ),
      },
      {
        path: 'pazienti',
        element: (
          <PermissionSpecificRoute
            permission="PATIENTS.READ"
            element={<PatientsList />}
          />
        ),
      },
      {
        path: 'pazienti/:patientId',
        element: (
          <PermissionSpecificRoute
            permission="PATIENTS.READ"
            element={<PatientDetails />}
          />
        ),
      },
      {
        path: 'terapie',
        element: (
          <PermissionSpecificRoute
            permission="THERAPIES.READ"
            relatedOnly={false}
            element={<TherapiesList />}
          />
        ),
      },
      {
        path: 'terapie/:therapyId',
        element: (
          <PermissionSpecificRoute
            permission="THERAPIES.READ"
            element={<TherapyDetail />}
          />
        ),
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
]);

export default router;
